import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=12ff0f1e&scoped=true"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"
import style0 from "./Signin.vue?vue&type=style&index=0&id=12ff0f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff0f1e",
  null
  
)

export default component.exports